import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid, ResponsiveContainer } from 'recharts';

const CustomLegend = ({ payload }) => {
    return (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
            {payload.map((entry, index) => (
                <div key={`item-${index}`} style={{ display: 'flex', alignItems: 'center', margin: '0 15px' }}>
                    <div style={{ width: 12, height: 12, borderRadius: '50%', backgroundColor: entry.color, marginRight: 5 }} />
                    <span className="custom-chart-legend-label" style={{ color: '#333', fontWeight: 'bold' }}>{entry.value}</span>
                </div>
            ))}
        </div>
    );
};

const CustomBarChart = ({ data = [], chartType }) => {
    const hasData = data.length > 0;

    const maxEarningsValue = hasData
    ? Math.max(...data.map(item => item.earnings))
    : 10; 

const maxDataValue = hasData
    ? Math.max(...data.map(item => Math.max(item.patientCount, item.appointmentCount)))
    : 100;
    const earningsTicks = () => {
        const tickInterval = Math.ceil(maxEarningsValue ? maxEarningsValue / 6 : 1000/6);
        return [...Array(7)].map((_, index) => ({
            value: index * tickInterval,
            key: `earnings-tick-${chartType}-${index}` 
        }));
    };



    const dynamicTicks = () => {
        const tickInterval = Math.ceil(maxDataValue ? maxDataValue / 5: 1000/6);
        return [...Array(6)].map((_, index) => ({
            value: index * tickInterval,
            key: `data-tick-${chartType}-${index}` 
        }));
    };

    const NoDataOverlay = () => (
        <div style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
            color: '#999',
            fontSize: '18px'
        }}>
            <p className="custom-chart-no-data">No Data Available</p>
            <span role="img" aria-label="no-data">📊</span>
        </div>
    );

    return (
        <div className="custom-bar-chart-surface" style={{ position: 'relative', height: '300px', backgroundColor: '#ffffff', borderRadius: '8px' }}>
            {!hasData && <NoDataOverlay />}
            <ResponsiveContainer width="100%" height="100%">
                <BarChart data={data}>
                    <CartesianGrid strokeDasharray="2 3" stroke="#ddd" />
                    <XAxis
                        dataKey="name"
                        tick={{ textAnchor: 'middle' }}
                        fontSize={12}
                        interval={0}
                        style={{ fill: '#333' }}
                        height={40}
                    />
                    <YAxis
                        yAxisId="left"
                        tickCount={earningsTicks().length}
                        interval={0}
                        domain={[0, maxEarningsValue * 1.1]}
                        ticks={earningsTicks().map(tick => tick.value)} 
                        style={{ fill: '#333' }}
                    />
                    <YAxis
                        yAxisId="right"
                        orientation="right"
                        tickCount={dynamicTicks().length}
                        interval={0}
                        domain={[0, maxDataValue * 1.1]}
                        ticks={dynamicTicks().map(tick => tick.value)} 
                        style={{ fill: '#333' }}
                    />
                    <Tooltip contentStyle={{ backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '5px' }} />
                    <Legend content={<CustomLegend />} />
                    <Bar
                        yAxisId="left"
                        dataKey="earnings"
                        fill="#03C3AC"
                        name="Earnings"
                        radius={[10, 10, 0, 0]}
                        animationDuration={500}
                    />
                    <Bar
                        yAxisId="right"
                        dataKey="patientCount"
                        fill="#68B2FF"
                        name="Patient Count"
                        radius={[10, 10, 0, 0]}
                        animationDuration={500}
                    />
                    <Bar
                        yAxisId="right"
                        dataKey="appointmentCount"
                        fill="#E785FA"
                        name="Appointment Count"
                        radius={[10, 10, 0, 0]}
                        animationDuration={500}
                    />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default CustomBarChart;
